export default "__VITE_ASSET__Dem1htL0__"